export enum TipoTramiteCode {
    CambioComposicionFamiliarInclusion = "CambioComposicionFamiliarInclusion",
    EvaluacionNuevoHogar = "EvaluacionNuevoHogar",
    CambioJefeHogarFallecimiento = "TramiteCambioJefeHogarFallecimiento",
    CambioJefeHogarDiscapacidad = "TramiteCambioJefeHogarDiscapacidad",
    CambioJefeHogarMutuoAcuerdo = " TramiteCambioJefeHogarMutuoAcuerdo",
    CambioJefeHogarAusenciaDefinitivaYAbandono = "TramiteCambioJefeHogarAusenciaDefinitivaAbandono",
    CambioDireccion = "TramiteCambioDireccion",
    ReclamoConsumoNoAutorizado = "TramiteReclamoConsumoNoAutorizado",
    ReevaluaccionHogar = "TramiteReevaluaccionHogar",
    SolicitudRc = "SolicitudRc"
}